export default __webpack_public_path__ + "static/media/CarImages.SportagLarge.4b8012f3.jpg";